"use client";

import React from "react";
import { Atom, Beaker, Microscope, Settings } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Ausiliari Tessili",
  description: "Soluzioni chimiche avanzate per il finissaggio e la nobilitazione dei tessuti.",
  icon: Atom
}, {
  title: "Materie Prime",
  description: "Fornitura di reagenti e composti chimici industriali di alta purezza per processi produttivi B2B.",
  icon: Beaker
}, {
  title: "Strumenti e Consumabili",
  description: "Equipaggiamento tecnico e materiali di consumo per laboratori di analisi e controllo qualità.",
  icon: Microscope
}, {
  title: "Macchinari",
  description: "Sistemi e tecnologie industriali per l'ottimizzazione della produzione chimica e tessile.",
  icon: Settings
}];
export default function LeNostreForniture() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="le-nostre-forniture" ref={ref} className={`py-24 px-6 bg-muted/30 transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      
    </section>;
}